var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "bg-white w-full pr-3" }, [
    _c(
      "div",
      { staticClass: "mx-auto py-0 flex" },
      [
        _vm.$vuetify.breakpoint.xs && _vm.sandwich
          ? _c("v-app-bar-nav-icon", {
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.$emit("sandwich")
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "h1",
          {
            class: [
              "leading-tight font-bold align-center flex z-40",
              _vm.large && _vm.$vuetify.breakpoint.smAndUp
                ? "large-header"
                : "medium-header",
              _vm.text.length > 18 && _vm.$vuetify.breakpoint.xs
                ? "small-header"
                : null,
              _vm.$page.component == "Explore" ? "white--text" : "soli-grey",
            ],
          },
          [
            _vm.$attrs.href
              ? _c(
                  "Link",
                  _vm._b(
                    {
                      staticStyle: { "margin-left": "-18px" },
                      attrs: { "preserve-scroll": "" },
                    },
                    "Link",
                    _vm.$attrs,
                    false
                  ),
                  [
                    _c(
                      "v-btn",
                      { attrs: { icon: "" } },
                      [_c("v-icon", [_vm._v("chevron_left")])],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("title", function () {
              return [
                _vm._v(
                  "\n                " + _vm._s(_vm.text) + "\n            "
                ),
              ]
            }),
            _vm._v(" "),
            !_vm.isScrolled &&
            _vm.$page.props.staffView &&
            _vm.can("Impersonate students") &&
            _vm.$page.component == "ShowUser" &&
            _vm.$page.props.profile?.loginable
              ? _c(
                  "v-btn",
                  {
                    attrs: { icon: "" },
                    on: {
                      click: function ($event) {
                        return _vm.impersonate()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "soli-blue-text" }, [
                      _vm._v("visibility"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isScrolled &&
            _vm.$page.props.staffView &&
            _vm.is("Admin") &&
            _vm.$page.component == "ShowUser" &&
            _vm.$page.props.profile.stripe_id
              ? _c(
                  "v-btn",
                  {
                    attrs: {
                      href: `https://dashboard.stripe.com${
                        _vm.$page.props.version.dev ? "/test" : ""
                      }/customers/${_vm.$page.props.profile.stripe_id}`,
                      target: "_blank",
                      icon: "",
                    },
                  },
                  [
                    _c("v-img", {
                      attrs: {
                        contain: "",
                        width: 64,
                        src: "/stripe_logo.png",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm._t("tools"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }